import axios from "../../utils/axios";

export const updateLike = async (id, blogLikes) => {
    const response = await axios.patch(`/blogs/${id}`, {
        likes: blogLikes,
    });
    return response.data;
};

export const updateBookmark = async (id, isSaved) => {
    const response = await axios.patch(`/blogs/${id}`, {
        isSaved: isSaved,
    });
    return response.data;
};
